import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { PanelContainer } from './styles';
import colors from '../../../../../styles/colors';

const Panel = ({ header, children, ...props }) => (
  <PanelContainer
    header={
      <h4 style={
        {
          font: 'Roboto',
          fontSize: '16px',
          fontWeight: '600',
          lineHeight: '24px',
          marginTop: '0.3rem',
          marginBottom: '0.3rem',
        }
      }
      >
        <ExclamationCircleOutlined
          size={18}
          style={{ color: colors.$auxiliary_yolk_5, marginRight: '11px' }}
        />
        <b>Alterações agendadas</b>
      </h4>
    }
    {...props}
  >
    {children}
  </PanelContainer>
);

Panel.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default Panel;
